export default {
  setFormValues (state, values) {
    state.formValues = values
  },
  setFormErrors (state, errors) {
    state.formErrors = errors
  }
}
